import { Enum } from '../../../common/constants'
import { extractApiErrorMessage } from '../../../helpers/apiErrorMessage'

export const PersonalTokenPrecheckStatuses = {
  UserNotFound: 'userNotFound',
  TenantNotFound: 'tenantNotFound',
  Ok: 'ok',
} as const

export type PersonalTokenPrecheckStatus = Enum<typeof PersonalTokenPrecheckStatuses>

export type PrecheckUser = {
  userId: string
  email: string
  displayName: string
  isActive: boolean
  isSuperUser: boolean
  tenantId: number
}

export type PrecheckTenant = {
  id: number
  name: string
  email: string
  active: boolean
}

export type PersonalTokenPrecheckResult = {
  status: PersonalTokenPrecheckStatus
  user: PrecheckUser | null
  tenant: PrecheckTenant | null
  planName: string
  roles: string[]
  activePersonalTokenCreatedDates: string[]
  hasAdministratorRole: boolean
  isProPlan: boolean
  hasActivePersonalToken: boolean
}

export type IssuePersonalTokenResult = {
  wasIssued: boolean
  token: string | null
  error: string | null
}

export const getPrecheckWarnings = (result: PersonalTokenPrecheckResult): string[] => {
  const warnings: string[] = []
  if (result.user && !result.user.isActive) {
    warnings.push('This user is not active.')
  }
  if (!result.isProPlan) {
    warnings.push('This user is not on the Pro plan.')
  }
  if (!result.hasAdministratorRole) {
    warnings.push('This user does not have the Administrator role.')
  }
  if (result.hasActivePersonalToken) {
    const count = result.activePersonalTokenCreatedDates.length
    warnings.push(`This user already has ${count} active personal ${count === 1 ? 'token' : 'tokens'}.`)
  }
  return warnings
}

export const getIssueErrorMessage = (error: unknown): string =>
  extractApiErrorMessage(error, 'There was an error issuing the token.')
